'use client'

import { useEffect } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { selectGraftcodeOnboardingRequiredWizardState } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.selector'
import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

import { GRAFTCODE_ONBOARDING_PHASE } from '../graftcode-onboarding.const'

/** Opens the setup wizard until the user completes goal + scenario (no dismiss in UI). */
export function useGraftcodeOnboardingRequiredWizard(enabled: boolean) {
  const { hydrated, wizardCompleted, phase, openWizard } = useGraftcodeOnboardingStore(
    useShallow(selectGraftcodeOnboardingRequiredWizardState)
  )

  useEffect(() => {
    if (!enabled || !hydrated || wizardCompleted || phase === GRAFTCODE_ONBOARDING_PHASE.wizard) {
      return
    }
    openWizard()
  }, [enabled, hydrated, wizardCompleted, phase, openWizard])
}
